export const OPEN_EDGE_TOKEN_ERROR = {
  INVALID_INPUT: 'invalid_input',
  INVALID_CARD: 'invalid_card'
};

export const OPEN_EDGE_INVALID_INPUT_ERROR_DATA_PATH = {
  EXPIRY_MONTH: '/card/expiry_month',
  EXPIRY_YEAR: '/card/expiry_year',
  CARD: '/card/card_number',
  CVV: '/card/card_security_code'
};
